"use client";

// Tracks blob URLs minted by the demo image upload so they can be released when
// the demo resets. (Browsers free object URLs on document unload anyway; this
// reclaims them within a long-lived session.) Kept in its own module so the
// demo backend and the demo store can share it without a circular import.
const demoImageUrls = new Set<string>();

/** Register a freshly-created object URL and return it unchanged. */
export function trackDemoImageUrl(url: string): string {
    demoImageUrls.add(url);
    return url;
}

/** Revoke one tracked URL as soon as its demo image is displaced. */
export function revokeDemoImageUrl(url: string | null | undefined): void {
    if (!url || !demoImageUrls.delete(url)) return;
    try {
        URL.revokeObjectURL(url);
    } catch {
        // best effort
    }
}

/** Revoke and forget every tracked demo image URL. */
export function revokeDemoImageUrls(): void {
    for (const url of demoImageUrls) {
        try {
            URL.revokeObjectURL(url);
        } catch {
            // best effort
        }
    }
    demoImageUrls.clear();
}
